import { css } from '@emotion/css';
import { spacing, shadows } from '@prezzee/tokens';
import CmsImage from 'components/CmsImage';

import { useProduct } from 'contexts/ProductPageContext';

const Styles = {
  card: (zagBanner: boolean) => css`
    width: 100%;
    box-shadow: ${shadows.md};
    border-radius: 10px;
    margin-bottom: ${spacing.spacing02};

    & > img {
      margin: 0;
      border-radius: ${zagBanner ? '10px 10px 0 0' : '10px'};
      width: 100%;
    }
  `,
};

const CardDisplayImage = (): JSX.Element => {
  const { sku, cardCustomisationState, userUploadedDesignFileInput, isLayer } = useProduct();
  let src: string = '';
  let renderAsTemplate: boolean = false;

  if (!cardCustomisationState) return null;

  const { customCardDesignIsEnabled, initialCardDesign, selectedCardDesign, customThemeDesigns } =
    cardCustomisationState;

  if (!customCardDesignIsEnabled) {
    src = initialCardDesign?.imageUrl || '';
  } else {
    if (selectedCardDesign) {
      const { imageUrl, isTemplate, uid } = selectedCardDesign;
      renderAsTemplate = isTemplate;

      if (isTemplate && customThemeDesigns?.length) {
        const customThemeDesign = customThemeDesigns.find(t => t.templateUid === uid);
        src = customThemeDesign?.image || imageUrl;
      } else {
        src = imageUrl;
      }
    } else if (initialCardDesign) {
      const { imageUrl, isTemplate } = initialCardDesign;
      renderAsTemplate = isTemplate;
      src = imageUrl;
    }
  }

  const handleClick = (ev: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
    ev.preventDefault();
    if (renderAsTemplate && userUploadedDesignFileInput?.current) {
      userUploadedDesignFileInput.current.click();
    }
  };

  const Element = renderAsTemplate ? 'button' : 'div';
  const desktopSm = '(max-width: 1124px)';
  const tabletLg = '(max-width: 990px)';
  return (
    <Element
      title={renderAsTemplate ? 'Tap to add your own image' : undefined}
      aria-label={renderAsTemplate ? 'Tap to add your own image' : undefined}
      onClick={handleClick}
      className={Styles.card(false)}
    >
      {src && (
        <CmsImage
          src={src}
          alt={sku.displayName + ' gift card image'}
          width={452}
          height={280}
          sizes={`${tabletLg} 100vw, ${desktopSm} 39vw, 393px`}
          priority={true}
        />
      )}
    </Element>
  );
};

export default CardDisplayImage;
